module.exports = __webpack_public_path__ + "img/masterMap.66823f52.jpg";